import {
  BgColorsOutlined,
  CopyOutlined,
  FontSizeOutlined,
  HeartOutlined
} from '@ant-design/icons';

export const SIDEBAR_OPTIONS = [
  {
    key: 'pages',
    label: 'Pages',
    icon: CopyOutlined
  },
  {
    key: 'colors',
    label: 'Colors',
    icon: BgColorsOutlined
  },
  {
    key: 'logo',
    label: 'Logo',
    icon: HeartOutlined
  },
  {
    key: 'fonts',
    label: 'Fonts',
    icon: FontSizeOutlined
  }
] as const;

export type SidebarOptionKey = (typeof SIDEBAR_OPTIONS)[number]['key'];
